module.exports = __webpack_public_path__ + "static/img/a1afe4c180c8a90000e1bd60db656c0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_adv4.jpg
// module id = Fdlf
// module chunks = 1